export const ALLOW_LIST = new Set<string>([
  // pxtcms team --start--
  '531830', //gourneni
  '112934439', //arvindia
  '104961246', //pottv
  '106051432', //pratgp
  '109270909', //chennabh
  '112210087', //abishkb
  '112984803', //imthias
  '113216747', //sharekhk
  '205923658', //vkacham
  '111989128', //deepumvc
  '202944930', //pavannsk
  '206043519', //jyoshil
  '206406043', //ranguyas
  '104628046', //vankrahu
  '104873209', //mitmurm
  '110905990', //pvkalyan
  '112508035', //jhimansz
  '113096103', //surapars
  '205923651', //itsvinai
  '103021991', //shanprat
  // pxtcms team --end--
  // pano migration team --start--
  '101954021', //gakansha
  '100524208', //shugopal
  '112757258', //srisaiii
  '109385204', //shubkh
  '106026730', //kishanpt
  '112891847', //sinhaujj
  '113185329', //tiwariig
  '112581270', //ayusss
  '108328293', //mqamz
  // product team
  '100457305' //randale
  // pano migration team --end--
]);
